const CONTENT_LIST = {
    EVENT: {
        VIEWED: 'ListViewed',
        FILTER: 'ListViewedFilter',
        PAGINATION: 'ListViewedPagination',
        HELP_VIEWED: 'HelpCenterListViewed',
    },
    EVENT_PROPERTIES: {
        DESCRIPTION: 'Compliance Section: ',
        TEMPLATE_DESCRIPTION: 'Template Section: ',
        HELP_DESCRIPTION: 'Help Section: ',
    },
};

export default CONTENT_LIST;
